class WIproductCardSlider extends HTMLElement{
    constructor() {
        super();
    }
    connectedCallback() {
        this.productCardSlider();
        this.sliderDisplay();
    }

    sliderDisplay() {
        this.style.display = "block";
    }

    productCardSlider() {
        let slides = this.querySelectorAll('.WI_slide');
        let nextBtn = this.querySelector('.WI_nextArrow');
        let prevBtn = this.querySelector('.WI_prevArrow');
        var counter = 0;
        slides.forEach((slid,index,array) => {
            slid.style.left = `${index * 100}%`;
            // console.log(array.length);
            let slideX;
            let slideEndX;
            slid.addEventListener('touchstart', e=>{
                let tArray = [...e.touches];
                tArray.forEach(arr => {
                    slideX = arr.pageX;
                });
                 
            })

            slid.addEventListener('touchend', e=>{
                let tmArray = [...e.changedTouches];
                // console.log(tmArray);
                tmArray.forEach(arr => {
                    slideEndX = arr.pageX;
                });
                // console.log(slideEndX + "==" +slideX);
                if (slideEndX < slideX) {
                    if (e.cancelable) {
                        e.preventDefault();
                    }
                    let numOfImg;
                    slides.forEach((img,index,array)=>{
                        // console.log(array.length);
                        numOfImg = array.length;
                    })
                    if (numOfImg - 1 !== counter){
                        counter++;
                    }
                    slidTrans();
                }
                if (slideEndX > slideX) {
                    if (e.cancelable) {
                        e.preventDefault();
                    }
                    if (counter !== 0){
                        counter--;
                    }
                    slidTrans();
                }
            })
        });

        nextBtn.addEventListener('click',(e)=>{
            e.preventDefault();
            let numOfImg;
            nextBtn.parentElement.querySelectorAll('.WI_slide').forEach((img,index,array)=>{
                // console.log(array.length);
                numOfImg = array.length;
            })
            if (numOfImg - 1 !== counter){
                counter++;
            }
            slidTrans();
        });
        

        prevBtn.addEventListener('click',(e)=>{
            e.preventDefault();
            if (counter !== 0){
                counter--;
            }
            slidTrans();
        });


        let slidTrans = () => {
            slides.forEach(trans => {
                trans.style.transform = `translateX(-${counter * 100}%)`;
                // console.log(`${counter * 100}`);
            });
        }
    }
}

customElements.define('wi-productcard-img-b', WIproductCardSlider);